import { Card, CardContent, Typography, Box, Stack } from "@mui/material";
import localStorageManagement from '../Security/LocalStorageManagement';

export default function CardItem({ info }) {
  const addViewToLocalStorage = () => {
    localStorageManagement.addSystemView(info);
  }

  const redirectTo = () => {
    addViewToLocalStorage();
    window.open(info.link, '_blank', 'noopener,noreferrer');
  }

  const svgFileName = info.title.replace(/\s+/g, '').replace(/[^a-zA-Z0-9]/g, '') + '.svg';
  const svgFilePath = `/imgsCards/${svgFileName}`;

  return (
    <Card
      onClick={redirectTo}
      sx={{
        width: { xs: "260px", sm: "220px", xl: "275px" },
        height: "340px",
        boxShadow: "3px 2px 11px 0px rgba(103, 103, 103, 0.25)",
        transition: "0.20s",
        textAlign: "center",
        ":hover": {
          cursor: "pointer",
          backgroundColor: "#fff2f4",
          boxShadow: "3px 2px 11px 0px rgba(59, 59, 59, 0.35)",
          transform: "translateY(-5px)",
          transition: "0.20s",
        },
      }}
    >
      <Box sx={{ height: "5px", backgroundColor: "#c5415c" }}></Box>
      <Stack
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "100%",
            marginBlock: "70px",
            height: { xs: 50, sm: 40, xl: 50 },
            width: { xs: 50, sm: 40, xl: 50 },
            backgroundColor: "rgba(250, 215, 222, 0.87)",
            boxShadow: "-1px 1px 19px 41px rgba(250, 215, 222, 0.87)",
          }}
        >
          <Box
            component="img"
            src={svgFilePath}
            sx={{
              width: { xs: 95, sm: 80, xl: 95 },
              height: { xs: 95, sm: 80, xl: 95 },
            }}
          />
        </Stack>
      </Stack>
      <CardContent sx={{ padding: 0 }}>
        <Typography
          sx={{
            marginBlock: "9px",
            fontWeight: 800,
            fontSize: {
              xs: '20px',
              sm: '18px',
              xl: '20px'
            }
          }}
        >
          {info.title}
        </Typography>

        <Typography
          variant="body2"
          color="textSecondary"
          sx={{
            fontSize: "12px",
            color: "grey",
            padding: "0px 20px",
            height: "54px",
            marginTop: "22.5px",
          }}
        >
          {info.shortDescription}
        </Typography>
      </CardContent>
    </Card>
  );
}
